// extracted by mini-css-extract-plugin
export var disabled = "_1c-a";
export var hierarchyLinkGray = "_1c-4";
export var hierarchyLinkUnderline = "_1c-3";
export var hierarchyPrimary = "_1c-0";
export var hierarchySecondary = "_1c-1";
export var hierarchyTertiary = "_1c-2";
export var pressed = "_1c-6";
export var themeAction = "_1c-5";
export var themeDestructive = "_1c-8";
export var themeNormal = "_1c-7";
export var themeSuccess = "_1c-9";